import request from '@/utils/request';

const path = 'api/v1';

const incoStorageList = data => request({
  url: `${path}/incoming/storages`,
  method: 'Get',
  params: data,
});

const incoStorageCreate = data => request({
  url: `${path}/incoming/storages`,
  method: 'Post',
  data,
});

const incoStorageUpdate = ({ orderNo, incoStoreId, ...data }) => request({
  url: `${path}/incoming/${orderNo}/storages/${incoStoreId}`,
  method: 'put',
  data,
});

const incoStorageAddBox = ({ orderNo, ...data }) => request({
  url: `${path}/incoming/${orderNo}/storages/opr/addBox`,
  method: 'put',
  data,
});

const incoStorageBoxDelete = ({ orderNo, incoStoreId, ...data }) => request({
  url: `${path}/incoming/${orderNo}/storages/${incoStoreId}/deleteBox`,
  method: 'put',
  data,
});

const incoStorageEntry = data => request({
  url: `${path}/incoming/storages/entry`,
  method: 'Post',
  data,
});

const storeDetailGet = data => request({
  url: `${path}/incoming/storages/detail`,
  method: 'Get',
  params: data,
});

const incoStorageDelivery = data => request({
  url: `${path}/incoming/storages/delivery`,
  method: 'Put',
  data,
});

const incoStorageReturn = data => request({
  url: `${path}/incoming/storages/cancelDelivery`,
  method: 'Post',
  data,
});

const incoStorageOprList = data => request({
  url: `${path}/incoming/storages`,
  method: 'Get',
  params: data,
});

const storeDetailByOprId = data => request({
  url: `${path}/incoming/storages/detail/byoprid`,
  method: 'Get',
  params: data,
});

const incoStorageCancelEntry = data => request({
  url: `${path}/incoming/storages/calcelentry`,
  method: 'Post',
  data,
});

const incoStorageDetailById = data => request({
  url: `${path}/incoming/storages/detail`,
  method: 'Get',
  params: data,
});

const incoStorageCancelDelivery = data => request({
  url: `${path}/incoming/storages/cancelDelivery`,
  method: 'Post',
  data,
});

const incoStorageAddCase = data => request({
  url: `${path}/incoming/box/case`,
  method: 'Post',
  data,
});

const incoStorageUpdateCase = data => request({
  url: `${path}/incoming/box/case`,
  method: 'Put',
  data,
});

const incoStorageDelCase = data => request({
  url: `${path}/incoming/box/case`,
  method: 'Delete',
  data,
});

export {
  incoStorageList,
  incoStorageCreate,
  incoStorageUpdate,
  incoStorageAddBox,
  incoStorageBoxDelete,
  incoStorageEntry,
  storeDetailGet,
  incoStorageDelivery,
  incoStorageReturn,
  incoStorageOprList,
  storeDetailByOprId,
  incoStorageCancelEntry,
  incoStorageDetailById,
  incoStorageCancelDelivery,
  incoStorageAddCase,
  incoStorageUpdateCase,
  incoStorageDelCase,
};
